var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergeeks30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ff2113",
    height: 32.5269,
    rx: 4.52247,
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -16.67767 7.736544)",
    width: 32.5269,
    x: 1,
    y: 24
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.7535 18.8491 3.4242-3.4242c.4541-.4542 1.1904-.4542 1.6446 0 .4541.4541.4541 1.1905 0 1.6446l-3.3672 3.3672c-1.0569 1.0569-1.7652 1.7687-2.2236 2.3695-.4379.5739-.5369.908-.5369 1.1938s.099.6199.5369 1.1938c.4584.6008 1.1667 1.3126 2.2236 2.3695l3.3672 3.3672c.4541.4541.4541 1.1905 0 1.6446-.4542.4542-1.1905.4542-1.6446 0l-3.4242-3.4242c-.9851-.985-1.8066-1.8064-2.3711-2.5463-.5958-.7808-1.0136-1.6058-1.0136-2.6046s.4178-1.8238 1.0136-2.6046c.5645-.7399 1.386-1.5613 2.3711-2.5463z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergeeks30);
export default __webpack_public_path__ + "static/media/energeeks30.17c256caff198c72812b7d37bd5c2857.svg";
export { ForwardRef as ReactComponent };